import { Component, Input, OnInit } from '@angular/core';
import { DirectoryModule } from '../../../directory/directory.module';
import { DirectoryAccessService } from '../../services/directory-access.service';

@Component({
    selector: 'app-insights-directory-cards',
    templateUrl: './insights-directory-cards.component.html',
    styleUrls: ['./insights-directory-cards.component.scss'],
})
export class InsightsDirectoryCardsComponent implements OnInit {
    loading: boolean = true;
    modules: DirectoryModule[];

    @Input() applicationPage: string;
    constructor(private directoryService: DirectoryAccessService) {}

    ngOnInit() {}

    ngAfterViewInit() {
        this.getModules();
    }

    getModules() {
        if (this.applicationPage) {
            this.directoryService.get(this.applicationPage).subscribe((data) => {
                let tmpModules = data.filter((x) => !x.routerURL.includes('reporting'));
                this.modules = tmpModules;
                this.loading = false;
            });
        } else {
            this.loading = false;
            this.modules = null;
        }
    }
}
